// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1fbBM","errorLogs":"styles_errorLogs__2BpFs"};